import axios from "axios"

export const frontAxios = axios.create({
  baseURL: process.env.REACT_APP_AXIOS+'/api',
  timeout: 1000 * 60 * 2,
})
